module.exports = __webpack_public_path__ + "static/img/1.3f60bd8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/4/zh/1.png
// module id = E7bH
// module chunks = 0